import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import './Search.scss';

const Search: React.FunctionComponent<any> = () => {
    const [ filter, setFilter ] = useState('');
    const history = useHistory();

    const setFilterText = (evt: any = {}) => {
        setFilter(evt.target.value);
    };

    const applyFilterSearch = () => {
        history.push(`/productos?filter=${filter}`);
    };
    
    const onKeyPress = (event: any = {}) => {
        if (event.key === 'Enter' && filter) {
            applyFilterSearch();
        }
    };
    
    return (
        <div className="SearchContainer">
            <form className="navbar-form navbar-left search-form">
                <div className="form-group">
                    <input 
                        onKeyPress={onKeyPress}
                        onChange={setFilterText}
                        className="form-control search-input pull-left"
                        placeholder="Buscar..." />
                    <button
                        type="submit"
                        className="btn btn-default search-btn pull-left">
                        <span className="glyphicon glyphicon-search" aria-hidden="true"></span>
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Search;